<template>
    <button type="button" class="btn btn-primary-lighter m-1 float-end" @click="openModal">
        {{ button_denomination }}
    </button>

    <Teleport to="body">
        <div class=" modal modal-fade" :id="'singleTrainingModal-' + id_to_open" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-sm ">
                <div class="modal-content">
                    <div class=" modal-header ">
                        <div class="row">
                            <div class="col-12">
                                <h2>{{ $trans.get('__JSON__.Create Single Training for') }} {{ payload.name }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="text-center modal-body" id="mediumBody">
                        <!-- <span class="text-center material-symbols-outlined material-symbols-error">
                                    error
                                </span> -->
                        <div class="text-center alert alert-block alert-danger">
                            <singleselect-employees @selectedemployee-Changed="setSelectedEmployee"
                                :employees="employees"></singleselect-employees>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="!saving" type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Cancel") }}
                        </button>
                        <button v-if="!saving" type="button" class="btn btn-primary" @click="singleTrainingHandler">
                            {{ $trans.get("__JSON__.create") }}
                        </button>
                        <span v-if="saving">{{ $trans.get("__JSON__.saving") }}...</span>

                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import singleTraining from '../composables/singleTraining';

export default {
    setup() {
        const { singleTrainingResponse, singleTraining_error, addEmployeeResponse, addEmployee_error, create, addEmployee } = singleTraining();
        return { singleTrainingResponse, singleTraining_error, addEmployeeResponse, addEmployee_error, create, addEmployee };
    },
    name: "CreateSingleTrainingButton",
    created() {
    },
    props: {
        id_to_open: String,
        modal_to_open: String,
        payload: Object,
        employees: Object,
        button_denomination: String,
    },
    data() {
        return {
            saving: false,
            selectedEmployee: [],
            errors: [],
            training: [],
            trainingParticipant: [],
        };
    },
    computed: {
    },
    mounted() {
    },
    watch: {
        singleTrainingResponse: function (newValue, oldValue) {
            if(newValue) {
                this.training = newValue;
            } else {
                this.training = [];
            }
        },
        addEmployeeResponse: function (newValue, oldValue) {
            if(newValue) {
                this.trainingParticipant = newValue;
            } else {
                this.trainingParticipant = [];
            }
        },
        training: function (newValue, oldValue) {
            if (Object.keys(this.training).length > 0) {
                if (this.training.id) {
                    let employeeData = {
                        employee_id: this.selectedEmployee.value,
                        training_id: this.training.id,
                    };
                    this.addEmployee(employeeData);
                }
            }
        },
        trainingParticipant: function (newValue, oldValue) {
            if (this.trainingParticipant.ok == 1) {
                $('#singleTrainingModal-' + this.id_to_open).modal("hide");
                this.saving = false;
                document.location.href = '/trainings/' + this.training.id + '/edit'
            }
        }
    },
    methods: {
        openModal() {
            $('#singleTrainingModal-' + this.id_to_open).modal("show");
        },
        singleTrainingHandler() {
            this.saving = true;
            let trainingBase = {
                qualification_id: this.id_to_open,
                qualification_name: this.button_denomination,
                employee_name: this.selectedEmployee.label.en,
            };
            this.create(trainingBase);
        },
        setSelectedEmployee(selectedEmployeesSingleSel) {
            this.selectedEmployee = selectedEmployeesSingleSel;
        },
    }
};
</script>
